export class ITable {
  exist: number;
  tables: any;
  orderFreeName: any;
}
export class TableDTO implements ITable {
  exist: number;
  tables: any;
  orderFreeName: any;
}

export default class Table extends TableDTO {
  constructor(dto?: TableDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      exist: 0,
      tables: [],
      orderFreeName: []
    });
  }

  public getLimitAlertTime() {
    return (this.tables[0].limitAlertTime !== "") ? this.tables[0].limitAlertTime : "0"
  }

  public getElapsedMinute() {
    return ((this.tables[0]) && this.tables[0].elapsedMinute) ? this.tables[0].elapsedMinute : 0
  }
}
